import { Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { CampoFormik } from '../../../components/CompUtils';
import es from '../../../yup-es';
import { cvTiposSelector } from '../cvSlice';
import FormikContainer from './FormikContainer';
yup.setLocale(es);

//
// ─── SCHEMA IDIOMAS ────────────────────────────────────────────────
//

const IdiomasSchema = yup.object({
  idIdiomaExtranjero: yup.number(),
  idIdiomaNombre: yup.number().required(),
  nombre: yup.string().required(),
  institucion: yup.string(),
  idPais: yup.number(),
  f_certificacion: yup.date().required(),
  idNivelIdiomaExtranjero: yup.number().required(),
});

//
// ─── FORMULARIO IDIOMAS ──────────────────────────────────────────────────
//

export const FormIdiomas = ({ formState }) => {
  const extra = useSelector(cvTiposSelector);
  const niveles = extra.nivelesIdiomas;
  const idiomas = extra.idiomas;

  return (
    <FormikContainer schema={IdiomasSchema} seccionKey="idiomas" seccionTitle="Idioma extranjero">
      {(formik) => (
        <>
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label for="idioma">Idioma (obligatorio):</Form.Label>
              <Form.Control
                aria-required
                id="idioma"
                as="select"
                name="idIdiomaNombre"
                value={formik.values.idIdiomaNombre}
                onChange={(ev) => {
                  formik.setFieldValue('nombre', idiomas[ev.target.value].nombre);
                  formik.setFieldValue('idIdiomaNombre', ev.target.value); // Agregar esta línea para actualizar idIdiomaNombre
                  formik.handleChange(ev);
                }}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.idIdiomaNombre && !!formik.errors.idIdiomaNombre}>
                <option value="">Seleccione</option>
                {Object.keys(idiomas).map((key, idx) => (
                  <option value={idiomas[key].id} key={idiomas[key].id}>
                    {idiomas[key].nombre}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">{formik.errors.nivel}</Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label for="nivel">Nivel (obligatorio):</Form.Label>
              <Form.Control
                aria-required
                id="nivel"
                as="select"
                name="idNivelIdiomaExtranjero"
                value={formik.values.idNivelIdiomaExtranjero}
                onChange={(ev) => {
                  formik.setFieldValue('idNivelIdiomaExtranjero', ev.target.value); // Agregar esta línea para actualizar idNivelIdiomaExtranjero
                  formik.handleChange(ev);
                }}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.nivel && !!formik.errors.nivel}>
                <option value="">Seleccione</option>
                {Object.keys(niveles).map((key, idx) => (
                  <option value={niveles[key].id} key={niveles[key].id}>
                    {niveles[key].nombre}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">{formik.errors.nivel}</Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <CampoFormik
              aria-required
              name="institucion"
              label="Institución o establecimiento (obligatorio)"
              formik={formik}
            />
          </Form.Row>
          <Form.Row>
            <CampoFormik type="pais" label="País" name="idPais" optional formik={formik} />
          </Form.Row>
          <Form.Row>
            <CampoFormik
              aria-required
              col={{ sm: 4 }}
              type="date"
              name="f_certificacion"
              label="Fecha de certificación (obligatorio)"
              formik={formik}
            />
          </Form.Row>
        </>
      )}
    </FormikContainer>
  );
};
